import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowEnter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15 0v7H1m0 0 3.5-3.5M1 7l3.5 3.5" />
  </svg>
);
const Memo = memo(SvgArrowEnter);
export default Memo;
